// Lib
import { connect } from 'react-redux';

// Constants
import { EDITOR_STORE_NAME } from '../editorConstants';

export default (...args) => {
    const opts = {
        ...args[3],
        storeKey: EDITOR_STORE_NAME,
        getDisplayName: (component) => `EditorStoreConnect(${component})`,
    };
    return connect(args[0], args[1], args[2], opts);
};
